<template lang="pug">
.status-badge-ove(:style="badgeStyle")
  span.status-text {{ label }}
</template>

<script>
export default {
  name: 'StatusBadgeOVE',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    label() {
      const labels = {
        cotizacion_enviada: 'C. Enviada',
        oportunidad_cerrada: 'Op. Cerrada',
        oportunidad_rechazada: 'Op. Rechazada',
        vencida: 'Vencida',
      }
      return labels[this.status.toLowerCase()] || this.status
    },
    badgeStyle() {
      const colors = {
        cotizacion_enviada: '#4b7bec',
        oportunidad_cerrada: '#2bcbba',
        oportunidad_rechazada: '#eb3b5a',
        vencida: '#fd9644',
      }
      return {
        backgroundColor: colors[this.status.toLowerCase()] || '#525252',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.status-badge-ove {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 8px;
  height: 30px;
  min-width: 120px;

  .status-text {
    font-family: 'Noto Sans', sans-serif;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    white-space: nowrap;
  }
}
</style>
